import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./core/services/store";
import '../public/custome.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
//import ApiService from "./core/services/api.service";
//import MockService from "./core/mock/mock.service";
//import { VERIFY_AUTH } from "./core/services/store/auth.module";
import { RESET_LAYOUT_CONFIG } from "@/core/services/store/config.module";

Vue.config.productionTip = false;
// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";
window.PerfectScrollbar = PerfectScrollbar;
import ClipboardJS from "clipboard";
window.ClipboardJS = ClipboardJS;
import moment from "jalali-moment";
// Vue 3rd party plugins
import i18n from "./core/plugins/vue-i18n";
import vuetify from "./core/plugins/vuetify";
import "./core/plugins/portal-vue";
import "./core/plugins/bootstrap-vue";
import "./core/plugins/perfect-scrollbar";
import "./core/plugins/highlight-js";
import "./core/plugins/inline-svg";
import "./core/plugins/apexcharts";
import "./core/plugins/metronic";
import install from "./core/plugins/ToastHelper";
import "@mdi/font/css/materialdesignicons.css";
import "vue-select/dist/vue-select.css";
Vue.use(install)
// import VueToast from 'vue-toast-notification';
// import 'vue-toast-notification/dist/theme-default.css';
// Vue.use(VueToast);
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
Vue.use(VuePersianDatetimePicker, {
  name: 'date-picker',
  props: {
      inputFormat: 'YYYY/MM/DD',
      format: 'jYYYY/jMM/jDD',
      editable: false,
      inputClass: 'form-control my-custom-class-name',
      placeholder: 'تاریخ را انتخاب کنید',
      altFormat: 'YYYY/MM/DD',
      color: '#0B8D71',
      autoSubmit: true
  }
});
Vue.use(require('vue-jalali-moment'));
import { VueMaskDirective } from 'v-mask'
Vue.directive('mask', VueMaskDirective);

import DisableAutocomplete from 'vue-disable-autocomplete';
Vue.use(DisableAutocomplete);


import HighCharts from 'highcharts'
import heatmap from 'highcharts/modules/heatmap';

heatmap(HighCharts);

import Echo from "laravel-echo";

window.Pusher = require("pusher-js");
window.Echo = new Echo({
  broadcaster: 'pusher',
  key: 'ac8a3144c04cfc84edee',
  cluster: 'eu',
});

// window.Echo = new Echo({
//     broadcaster: "pusher",
//     key: 'ac8a3144c04cfc84edee',
//     cluster: 'eu',
//     encrypted: true
    
// });


// var onlineTime = 1800;
// Vue.mixin({
//   data: function() {
//     return {
//       get globalOnlineTime() {
//         if (localStorage.getItem('onlinetile') != null) {
//           return localStorage.getItem('onlinetile');
//         }
//         return 1800;
//       },
//       set globalOnlineTime(value){
//         localStorage.setItem('onlinetile' , value);
//       }
//     }
//   }
// })

// var VueDragula = require('vue-dragula');
// Vue.use(VueDragula);



// API service init
//ApiService.init();

// Remove this to disable mock API
//MockService.init();
String.prototype.toEnDigits = function () {
  var num_dic = {
    '۰': '0','۱': '1','۲': '2','۳': '3','۴': '4','۵': '5',
    '۶': '6','۷': '7','۸': '8','۹': '9',
  }
  return this.replace(/[۰-۹]/g, function (w) {
    return num_dic[w]
  });
}
router.beforeEach((to, from, next) => {
  // reset config to initial state
  //store.dispatch(RESET_LAYOUT_CONFIG);

  // Ensure we checked auth before each page load.
  // Promise.all([sessionHelper.isUserValid()]).then(next);
  // if(sessionHelper.isUserValid()){
  //   //next(to);
  // }

  // if (to.name !== 'login' && !sessionHelper.isUserValid()) {
  //   next({ name: 'login' });
  // }
  // else {
  //   next()
  // }
  next()

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

const vm = new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount("#app");
